import React from 'react';

// Helper function to convert HSL color values to a Hexadecimal string
// This ensures we can generate truly random *bright* colors.
function hslToHex(h, s, l) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

// Function to generate a random bright color using HSL values
const getRandomBrightColor = () => {
  const h = Math.random() * 360; // Hue: 0-360 degrees (full spectrum)
  const s = Math.floor(Math.random() * 30) + 70; // Saturation: 70-100% (ensures vibrant color)
  const l = Math.floor(Math.random() * 20) + 60; // Lightness: 60-80% (ensures brightness, not too dark)
  return hslToHex(h, s, l);
};

function MessageList({ messages, messagesEndRef }) {
  //console.log(messages)
  return (
    <div className="message-list-container2">
      {messages.map((msg) => (
          // Use msg.id as key for efficient rendering, essential for React lists
          <div key={msg.id} className="message-bubble2">
            <span className="message-sender2" style={{color: getRandomBrightColor()}}>{msg.name}: </span>
            <span className="message-text2">{msg.text}</span>
          </div>
      ))}
      <div ref={messagesEndRef} /> {/* Element to scroll into view for auto-scrolling */}
    </div>
  );
}

export default MessageList;